import { dateUtils } from '@noths/polaris-client-utils';
import * as R from 'ramda';

import { DeliveryOptionInfo } from '../DeliveryBlock/components/DeliveryBlock';
import { copy } from './constants';

type DeliveryOption = Pick<DeliveryOptionInfo, 'exactDate' | 'date' | 'min' | 'max'>;

export const getReplacedPlaceholder = R.flip(R.replace(copy.DELIVERY_EVENT_PLACEHOLDER));

export const hasExactDeliveryDate = ({ exactDate, date }: DeliveryOption) =>
  exactDate && date != null;

export const isLateDelivery = (date: Date | string, constrainingDate: Date | string) =>
  dateUtils.isAfter(date, constrainingDate);

export const getMinDeliveryDate = (min: number) => dateUtils.getWithAddedDays(new Date(), min);

export const getMaxDeliveryDate = (max: number) => dateUtils.getWithAddedDays(new Date(), max);

export const isLateForEvent = (option: DeliveryOption, lastDeliveryBy: string | Date) => {
  if (hasExactDeliveryDate(option) && isLateDelivery(option.date!, lastDeliveryBy)) {
    return true;
  }

  const maxDeliveryDate = getMaxDeliveryDate(option.max!);
  const isMaxDeliveryDateLate = maxDeliveryDate && isLateDelivery(maxDeliveryDate, lastDeliveryBy);

  return isMaxDeliveryDateLate;
};
